export const INFISICAL_PROJECT_ID = 'infisical/project-id';
